import NoDataFound2 from './noDataFound2'
export default NoDataFound2
